import { render, staticRenderFns } from "./PdvClosedPrint.vue?vue&type=template&id=b3f2ee38"
import script from "./PdvClosedPrint.vue?vue&type=script&lang=js"
export * from "./PdvClosedPrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports